import { MiniEventCard } from "../../../components";
import { renderMiniMarketsAmerican } from "./RenderMethods";
export class American extends MiniEventCard {
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    constructor(props) {
        super(props);
        this.renderMarkets = renderMiniMarketsAmerican;
        this.cardTypeClass = `rj-ev-list__${this.componentPrefix}--american`;
        this.buttonsHolderClass = `rj-ev-list__${this.componentPrefix}__buttons-holder--american`;
    }
}
//# sourceMappingURL=American.js.map